/**
 * Download helper that works on ALL browsers including Safari iOS.
 * Safari blocks data: URL downloads, so we convert to Blob URL.
 */
export function downloadBase64File(base64Data, fileName, mimeType) {
  try {
    // Decode base64 to binary
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // iOS Safari: use window.open with blob URL
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isIOS || isSafari) {
      // For Safari/iOS: open blob in new tab (triggers native download/preview)
      const blobUrl = URL.createObjectURL(blob);
      const newWindow = window.open(blobUrl, '_blank');
      if (!newWindow) {
        // Popup blocked — fallback to link click
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    } else {
      // Standard browsers: use anchor download
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
    }
    return true;
  } catch (e) {
    console.error("Download failed:", e);
    return false;
  }
}
